import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import { Dictionary } from "@/lib/Dictionary.type";
import { ResourceCollection } from "@/modules/api/resource.collection";

import FactoryRushCapacitySlot from "./factory-rush-capacity-slot.model";

export default class FactoryRushCapacitySlotRepository extends BasicRepository<FactoryRushCapacitySlot> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<FactoryRushCapacitySlot>,
    responseParser: ApiCollectionResponseParserService<FactoryRushCapacitySlot>
  ) {
    super("factory_rush_capacity_slots", api, objectBuilder, responseParser);
  }

  public async getByFactoryId(
    factoryId: string,
    useCache = true
  ): Promise<ResourceCollection<FactoryRushCapacitySlot>> {
    return this.fetchList({ factory: factoryId }, 1, 999, undefined, useCache);
  }

  protected prepareData(
    item: FactoryRushCapacitySlot
  ): Dictionary<string | number> {
    return {
      id: item.id,
      factory: item.factory,
      productGroup: item.productGroup,
      type: item.type,
      capacity: item.capacity,
    };
  }
}
